import React, { useState, useEffect } from "react";
import Styles from "./styles.module.scss"
import SideMenu from "../sideMenu/index";
import DashboardHeader from '../topbar';
import Tab from '../../components/tab';
import Resume from './resume';
import PersonalDetails from './personalDetails';
// import Accademic from './accademic';
import * as CONSTANTS from '../../utils/CONSTANTS';
import { makeSideBarActive, mixpanelEvents, submitMixPanel } from '../../utils/EllowUtils';
import { getDetails, sendCredentails, submitDetails, submitProfile, updateProfiles } from './services';
import { getIncontractCompany } from './services';
import NotificationAlert from "../../components/notification";
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom'
import mixpanelData, { userProfile, viewedpageMixpanel } from '../../utils/mixpanel';
import * as Utils from '../../utils/EllowUtils'
import { updateNotificationStatus } from "../../components/noticationTab/services";
import { getAPI } from "../../api/api";
import { REACT_APP_COMMON } from "../../utils/common";

function CRcreateResource(props: any) {

  let navigate = useNavigate();
  const [selected, setSelected] = useState<boolean>(false);
  const location: any = useLocation()
  const select: any = location.state ? location.state : {}
  const candidateLoginId: any = localStorage.getItem('ResourcesCandidateLoginId') || localStorage.getItem('candidateLoginId') || select.candidateLoginId || ''

  const tab: any = localStorage.getItem('ResourcesTab') || (location && location.state &&  location.state.tab) || ''
  const selector: number = select.selector ? select.selector : 0
  const [loginId, setLoginId] = useState<any>(candidateLoginId)


  const availId = localStorage.getItem('availableId')
  const menu = makeSideBarActive(CONSTANTS.crSideMenu, 1)

  const { notificationsId }: any = location.state || ''



  const userLoginId = localStorage.getItem('loginId')
  const [sourced, setSourced] = useState<string>()
  const [behalf, setBehalf] = useState<any>({})
  const [disable , setDisable] = useState<boolean>(false)
  const [disableProfileButton, setDisableProfileButton] = useState<boolean>(false)
  const [disableSkillButton, setDisableSkillButton] = useState<boolean>(false)
  const [disableAvailabilityButton, setDisableAvailabilityButton] = useState<boolean>(false)
  const [disablePreferenceButton, setDisablePreferenceButton] = useState<boolean>(false)
  const [allocationData, setAllocationData] = useState<any>({})
  const [candidateId, setCandidateId] = useState<string>('')
  const [candidateStatus, setCandidateStatus] = useState<string>('')
  const [notification, setNotification] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [surveyAnswers, setSurveyAnswers] = useState<any>()
  const [createdBy, setCreatedBy] = useState<string>('')
  const [rejectReason, setRejectReason] = useState<any>()
  const [resume, setResume] = useState<string | null>(null)
  const [candidateEmail, setCandidateEmail] = useState<string | null>(null)
  const [profileValues, setProfileValues] = useState<any>()
  const [preferenceValues, setpreferenceValues] = useState<{
    timeZone?: string[];
    salary: { billingType: string; currencyType: string; expectedPay: string };
    locationPreference: { remoteType: number | undefined; location: { id: string; name: string }[] }
    companyType: number;
  }>({
    timeZone: [],
    salary: { billingType: '', currencyType: '', expectedPay: '' },
    locationPreference: { remoteType: undefined, location: [] },
    companyType: 0
  })
  const [resumeError, setResumeError] = useState<string>('')
  const [surveySubmitted, setSurveySubmitted] = useState<boolean>(false)
  const [allData, setAllData] = useState<any>()
  const [type, setType] = useState<string>('success')
  const [icon, setIcon] = useState<boolean>(false)
  const [candidateName, setCandidateName] = useState<string>()
  const [skillValues, setSkillValues] = useState<{
    workExperience: number,
    jobRoles: { name: string, id: number }[],
    techStack: { experience: string; expertise: number | null; skill: { skillId: number | null; skillName: string; }; stackId: number | null; }[],
    cloudProficiency: { id: number; name: string }[];
    positionName: string,
    otherSkills: { skillId: number, skillName: string }[]
  }>({
    workExperience: 0,
    jobRoles: [], techStack: [{ experience: "", expertise: null, skill: { skillId: 1246, skillName: 'React' }, stackId: null }],
    cloudProficiency: [], positionName: "", otherSkills: []
  })

  const [experienceValues, setExperienceValues] = useState<{
    workHistory: { designation: string, companyName: string, description: string, startDate: number, endDate: number, stillWorking: boolean }[],
    project: { name: string, companyName: string, doneFor: string, contribution: string, skills: { skillName: string, skillId: number }[], link: string }[]
  }>({
    workHistory: [],
    project: []
  })

  const [academicValues, setAccademicValues] = useState<{
    education: { degree: string, institution: string, startDate: number, endDate: number, action: string }[],
    language: { name: string, proficiency: string, action: string, languageId?: string }[]
  }>({
    education: [],
    language: []
  })
  const [awardsValues, setAwardsValues] = useState<{
    awards: { name: string, certifiedYear: number, action: string, status: boolean }[],
    publication: { title: string, year: number, link: string, status: boolean }[]
  }>({
    awards: [],
    publication: []
  })
  const [companyNames, setCompanyNames] = useState<any>()
  // const [editorState, setEditorState] = React.useState(EditorState.createEmpty());
  const [englishProficiency , setEnglishProficiency] = useState<any>()
  const [profileSubmitted, setProfileSubmitted] = useState<boolean>(false)
  const [ellowScreeningCertifications, setEllowScreeningCertifications] = useState([])
  const [companyRating, setCompanyRating] = useState([])
  const [assesmentLevel, setAssesmentLevel] = useState()
  const [employeeId , setEmployeeId ] = useState<any>()
  const [credentialSent, setCredentialSent] = useState<boolean>(false)
  const [availabilityValues, setAvailabilityValues] = useState({
    availability: {
      availabilityId: 1,
      date: "",
      weeks: ''
    },
    contractType: 1,
    workType: 1,
    jobSearchCriteria: 1
  })
  const [jobRoleList, setJobRoleList] = useState<any>()




  useEffect(() => {
    viewedpageMixpanel();
  }, [])

  const updateNotification = (notificationId: any) => {

    updateNotificationStatus(notificationId).then((response: any) => {
      if (response && response.status === "success") {
      }
    });

    getAPI( REACT_APP_COMMON + '/job-roles').then((value: any) => {
      if (value && value.status === 1) {
        setJobRoleList(value.data)
      }
    })

  };

  useEffect(() => {
   
    if (notificationsId != '') {
      updateNotification(notificationsId);
    }
    if (candidateLoginId) {
      getUserDetails(candidateLoginId);
      getIncontractCompanyName(candidateLoginId);
    }
    if (tab) {
      setSelected(true)
    }

  }, [availId, selector])



  const getIncontractCompanyName = (loginId: string) => {

    getIncontractCompany(loginId).then((response) => {
      if (response && response.status === 1) {
        setCompanyNames(response.data)
      }
    })
  }

  const getUserDetails = (id: string | null) => {
    getDetails(id).then((response: any) => {
      if (response && response.status === 1) {
        if (response.data[0].candidate_status > 2 && response.data[0].candidate_status < 6) {
          setProfileSubmitted(true)
        }
        if (response.data[0].credentials_sent) {
          setCredentialSent(response.data[0].credentials_sent)
        } else {
          setCredentialSent(false)
        }

        const skillsName = response.data[0].profile_metadata && response.data[0].profile_metadata.techStack && response.data[0].profile_metadata.techStack.map((item: any) => { return (item.skill.skillName) })
        const otherSkills = response.data[0].profile_metadata && response.data[0].profile_metadata.otherSkills && response.data[0].profile_metadata.otherSkills.length > 0 && response.data[0].profile_metadata.otherSkills.map((item: any) => { return (item.skillName)})
        const jobRolesNames: string[] = response.data[0] && response.data[0].profile_metadata && response.data[0].profile_metadata.jobRoles && response.data[0].profile_metadata.jobRoles.map((item: { id: number, name: string }) => { return (item.name) })

        setEnglishProficiency(response.data && response.data[0].profile_metadata.englishProficiency)
        setSurveyAnswers(response.data && response.data[0].survey_result)
        setCreatedBy(response.data && response.data[0].created_by)
        setCandidateId(response.data && response.data[0].candidate_id)
        setLoginId(response.data && response.data[0].login_id)
        setCandidateStatus(response.data && response.data[0].candidate_status)
        setResume(response.data && response.data[0].resume_file_name)
        setAllData(response.data && response.data[0].profile_metadata)
        setAllocationData({ id: response.data && response.data[0].allocated_to, name: response.data && response.data[0].allocatedToUserName })
        setBehalf({ id: response.data && response.data[0].behalf_of, name: response.data && response.data[0].behalfOfName })
        setSourced(response.data && response.data[0].sourced_by)
        setRejectReason(response.data && response.data[0].reject_comment)
        setEllowScreeningCertifications(response.data && response.data[0].profile_metadata.ellowScreeningCertifications)
        setCompanyRating(response.data && response.data[0].profile_metadata.companyRatings)
        setAssesmentLevel(response.data && response.data[0].profile_metadata.assessmentLevel)
        setCandidateName(response.data && response.data[0].profile_metadata.firstName + ' ' + response.data && response.data[0].profile_metadata.lastName)
        setSurveySubmitted(response.data && response.data[0].is_survey_completed)
        setCandidateEmail(response.data && response.data[0].profile_metadata.email)
        setEmployeeId(response.data && response.data[0].employee_id)
        localStorage.setItem("profile_metadata", JSON.stringify(response.data && response.data[0].profile_metadata))        

        let porofDetails = {
          firstName: response.data[0].profile_metadata.firstName,
          lastName: response.data[0].profile_metadata.lastName,
          email: response.data[0].profile_metadata.email,
          phoneNumber: response.data[0].profile_metadata.phoneNumber,
          designation: response.data[0].profile_metadata.designation,
          expectedPay: response.data[0].profile_metadata.preference && response.data[0].profile_metadata.preference.salary.expectedPay,
          currencyType: response.data[0].profile_metadata.preference && response.data[0].profile_metadata.preference.salary.currencyType,
          billingType: response.data[0].profile_metadata.preference && response.data[0].profile_metadata.preference.salary.billingType,
          jobRoles: response.data[0].profile_metadata.jobRoles,
          workExp: response.data[0].profile_metadata.workExperience,
          noticePeriod: response.data[0].profile_metadata.availability && response.data[0].profile_metadata.availability.availabilityId === 3 ? response.data[0].profile_metadata.availability.weeks : '',
          workType: response.data[0].profile_metadata.workType
        }
        
        setProfileValues(porofDetails)

        skillValues.workExperience = response.data[0].profile_metadata.workExperience;
        skillValues.jobRoles = response.data[0].profile_metadata.jobRoles;
        skillValues.techStack = response.data[0].profile_metadata.techStack;
        skillValues.cloudProficiency = response.data[0].profile_metadata.cloudProficiency;
        skillValues.positionName = response.data[0].profile_metadata.positionName;
        skillValues.otherSkills = response.data[0].profile_metadata.otherSkills;
        setSkillValues({ ...skillValues })

        availabilityValues.availability = response.data[0].profile_metadata.availability
        availabilityValues.contractType = parseInt(response.data[0].profile_metadata.contractType)
        availabilityValues.workType = parseInt(response.data[0].profile_metadata.workType)
        availabilityValues.jobSearchCriteria = response.data[0].profile_metadata.jobSearchCriteria && parseInt(response.data[0].profile_metadata.jobSearchCriteria)
        setAvailabilityValues({ ...availabilityValues })
        // 'Work Type': data && Utils.checkWorkType(data.workType),
        // 'Contract Type': data && Utils.checkContractType(data.contractType),
        // 'Availability': data && Utils.checkAvailability(data.availability.availabilityId, data.availability.date),
        // setSelected(flag ? selected : selector ? selector : selected)
        // selector && flag

        experienceValues.workHistory = response.data[0].profile_metadata.workHistory
        experienceValues.project = response.data[0].profile_metadata.project
        setExperienceValues({ ...experienceValues })

        academicValues.education = response.data[0].profile_metadata.education
        academicValues.language = response.data[0].profile_metadata.language
        setAccademicValues({ ...academicValues })

        awardsValues.awards = response.data[0].profile_metadata.certification
        awardsValues.publication = response.data[0].profile_metadata.publication
        setAwardsValues({ ...awardsValues })

        let preference = {
          timeZone: typeof (response.data[0].profile_metadata.preference && response.data[0].profile_metadata.preference.timeZone) === 'object' ? response.data[0].profile_metadata.preference.timeZone : [],
          locationPreference: response.data[0].profile_metadata.preference && response.data[0].profile_metadata.preference.locationPreference,
          salary: response.data[0].profile_metadata.preference && response.data[0].profile_metadata.preference.salary,
          companyType: response.data[0].profile_metadata.preference && response.data[0].profile_metadata.preference.companyType && response.data[0].profile_metadata.preference.companyType
        }
        setpreferenceValues(preference)
        userProfile({
          '$name': response.data[0].profile_metadata.firstName + " " + response.data[0].profile_metadata.lastName,
          'loginId': response.data[0].login_id,
          '$email': response.data[0].profile_metadata.email,
          '$phone': response.data[0].profile_metadata.phoneNumber && response.data[0].profile_metadata.phoneNumber.toString() ? response.data[0].profile_metadata.phoneNumber.toString() : '',
          'Skills': skillsName && skillsName,
          'Other skills': otherSkills && otherSkills,
          'Job role': jobRolesNames && jobRolesNames,
          'Work experience': response.data[0].profile_metadata.workExperience,
          'Work type': response.data[0].profile_metadata.workType && Utils.checkWorkType(parseInt(response.data[0].profile_metadata.workType)),
          'Contract type': response.data[0].profile_metadata.workType && Utils.checkContractType(parseInt(response.data[0].profile_metadata.contractType)),
          'Career type': response.data[0].profile_metadata && response.data[0].profile_metadata.candidateWorkType,
          'Availability': response.data[0].profile_metadata && response.data[0].profile_metadata.availability && Utils.checkAvailabilityMixpanel(response.data[0].profile_metadata.availability),
          'Expected salary': response.data[0].profile_metadata.preference ? response.data[0].profile_metadata.preference.salary && response.data[0].profile_metadata.preference.salary.expectedPay + ' ' + response.data[0].profile_metadata.preference.salary.currencyType + ' ' + response.data[0].profile_metadata.preference.salary.billingType : 'Not Mentioned',
          'Allocated to': response.data[0].allocatedToUserName && response.data[0].allocatedToUserName,
          'Sourced by': response.data[0].sourced_by,
          'Source Name': response.data[0].behalfOfName,
          'Designation': response.data[0].profile_metadata && response.data[0].profile_metadata.positionName,
          'ellow status': response.data[0].candidate_status && Utils.checkCandidateStatus(response.data[0].candidate_status),
          'employee id': response.data[0].employee_id,
          'Level': response.data[0].profile_metadata && response.data[0].profile_metadata.assessmentLevel,
          'Country': response.data[0].profile_metadata && response.data[0].profile_metadata.country,
          'Nationality': response.data[0].profile_metadata && response.data[0].profile_metadata.nationality,
          "github link": response.data[0].profile_metadata && response.data[0].profile_metadata.github,
          "linkedIn link": response.data[0].profile_metadata && response.data[0].profile_metadata.linkedIn,
          "stackoverflow link":  response.data[0].profile_metadata && response.data[0].profile_metadata.stackoverflow, 
        }, response.data[0].login_id)
      }

    })
  }

  const updateUserDetails = (data: any) => {

    data.candidateId = candidateId;
    setMessage('details stored successfully')
    setNotification(true)
    setTimeout(() => {
      setNotification(false)
    }, 3000);
  }

  const updateProfileValues = (data: any, body?: any) => {

    if (data !== undefined && data.firstName) {
      setDisableProfileButton(true)
    }

    if (!body) {
      mixpanelEvents(data, candidateId)
    }
    delete data.type

    let values = {
      loginId: loginId ? loginId : localStorage.getItem('candidateLoginId'),
      // loginId: userLoginId,
      userLoginId: userLoginId,
      submittedBy: 'CS-RECRUITER',
      profileMetadata: data,
      candidateStatus: data.type === 'save' ? '1' : '2',
    }        
    updateProfiles(values).then((response: any) => {
      if (response && response.status === 1) {
        setLoginId(response.data[0].login_id)
        localStorage.setItem('candidateLoginId', response.data[0].login_id)
        localStorage.setItem("profile_metadata", JSON.stringify(response.data[0].profile_metadata))
        localStorage.setItem('availablityId', response.data[0].profile_metadata && response.data[0].profile_metadata.availability && response.data[0].profile_metadata.availability.availabilityId)

        if (response.data[0].profile_metadata && response.data[0].profile_metadata.availability && response.data[0].profile_metadata.availability.availabilityId === 2) {
          localStorage.setItem('date', response.data[0].profile_metadata.availability.date)
        }
        if (response.data[0].profile_metadata && response.data[0].profile_metadata.availability && response.data[0].profile_metadata.availability.availabilityId === 3) {
          localStorage.setItem('weeks', response.data[0].profile_metadata.availability.date)
        }
        if (data.type === 'submit') {
          setMessage('Details saved successfully')
        }
        else {
          setMessage('Profile submitted successfully')
        }
        // getUserDetails(response.data[0].login_id)
        setNotification(true)
        setType('success')
        setIcon(true)
        setTimeout(() => {
          setNotification(false)
          navigate('/CRresources')
        }, 3000);

      } else {
        setDisableProfileButton(false)
        setDisableSkillButton(false)
        setDisableAvailabilityButton(false)
        setDisablePreferenceButton(false)
        setType('error')
        setIcon(false)
        displayNotification(response && response.status === '2' ? 'Found Duplicate EmailId' : 'Failed! please try again')
        setDisableProfileButton(false)
      }
    })
  }

  const onClose = () => {
    setNotification(false)
  }



  const displayNotification = (message: string) => {
    setMessage(message)
    setNotification(true)
    setTimeout(() => {
      setNotification(false)
    }, 3000);
  }

  const submitCheck = (value: boolean, data: any) => {
   
  }



  const sentCredentials = () => {
    let data = {
      "loginId": loginId,
      "userLoginId": userLoginId
    }
    sendCredentails(data).then((response) => {
      if (response && response.status === 1) {
        setType('success')
        setIcon(true)
      }
      if (response && response.status === 2) {
        setType('error')
        setIcon(false)
      }
      getUserDetails(candidateLoginId);
      displayNotification(response.message)
    })
  }

  const BreadcrumsValues = ['CRResources', (profileSubmitted === true ? candidateName :'Create New Resources')]

  const clickHandler = () => {
    getUserDetails(loginId)
    displayNotification("Details saved successfully")
  }

  const closeModal = () => {

  }





  return (
    <section className="dashboardWrapper">
      <SideMenu menu={menu} />

      <div className="dashboardContent">
        <DashboardHeader searchChange={undefined} title={BreadcrumsValues}  />

        {notification && (
          <NotificationAlert
            onClose={() => setNotification(false)}
            closable={true}
            type={type}
            icon={icon}
          >
            {message}
          </NotificationAlert>
        )}
        {/* {confirmationModal && <ConfirmationModal submit={() => { updateProfileValues(tempData); setConfirmationModal(false) }} onClose={onClose} jobRole={select.positionName} />} */}
        <div className={Styles.profile}>
          {/* {selected ?  */}
            <div>
              <Resume sourcedBy={sourced} loginId={loginId} getUserDetails={getUserDetails} resume={resume} userLoginId={userLoginId}  />
              <PersonalDetails ClickHandler={updateProfileValues} defaultValues={profileValues} disable={disableProfileButton} profileSubmitted={profileSubmitted} jobRolesList={jobRoleList} />  
          </div>    
            {/* :
          <Preview showSubmit={false} candaidateData={allData} profileSubmitted={profileSubmitted} submitCheck={submitCheck} editClick={() => setSelected(true)} loginId={loginId} createdBy={createdBy} sentCredentails={sentCredentials} />} */}
        </div>
      </div>
    </section>
  );
}
export default CRcreateResource

